import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {PriceLevelScheduleEntityModel} from "../price-level-schedule-entity.model";
import {PriceLevelData} from "../../price-level/price-level.data";
import {PriceLevelScheduleData} from "../price-level-schedule.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {Plugin} from "../../../config";

@Component({
    selector: "wbo-price-level-schedule-edit-page",
    templateUrl: "./price-level-schedule-edit-page.component.html",
    providers: [provideEntityModel(PriceLevelScheduleEntityModel)]
})
export class PriceLevelScheduleEditPageComponent extends AbstractEditPage implements OnInit {
    Plugin = Plugin;

    priceLevelLocked: boolean = false;

    constructor(public model: PriceLevelScheduleEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService, false);
    }

    get data(): PriceLevelScheduleData {
        return <PriceLevelScheduleData>this.model.data;
    }

    ngOnInit(): void {
        if (this.editPageComponent.stackedPageContextService && this.editPageComponent.stackedPageContextService.params.parentEntity) {
            const priceLevel: PriceLevelData = this.editPageComponent.stackedPageContextService.params.parentEntity;
            this.data.priceLevelId = priceLevel.priceLevelId;
            this.data.priceLevel = priceLevel;
            this.priceLevelLocked = true;
        }
    }
}
